<app-navbar></app-navbar>
<div class="container">

    <nz-breadcrumb [nzAutoGenerate]="true" [nzRouteLabel]="'customBreadcrumb'" nzSeparator=">">
        <nz-breadcrumb-item>
            <a class="breadcrumb-link-first">Главная</a> 
        </nz-breadcrumb-item>
    </nz-breadcrumb>

    <h3 class="terms-title">О проекте Wineincognito</h3>
    <div class="about-text-content">
        <p class="about-text">
            Причиной ее посещения стало вовсе не наличие на выставке довольно весомой «винной зоны» с дегустациями вина
            (кстати, за это респект организаторам!) — хотя разливали всем и были очень радушны.
            И совсем не присутствие нескольких павильонов винных поставщиков (что согласитесь, тоже здорово), а
            небольшая, мало кому пока известная программа — WineIncognito.
        </p>
        <p class="about-text">
            Именно после прочтения краткого анонса о программе где-то в пучинах Интернета — я и поспешил
            зарегистрироваться и пойти «подивиться» на нее.
            Вместо обычного (как я думал) прослушивания анонса программы, «ваш покорный слуга» попал прямиком в самую
            гущу ее работы.
        </p>
        <p class="about-text">
            В зале, за дюжиной столов, я обнаружил около 30 «мэтров» энологического рынка, проводящих «слепую»
            дегустацию около 300 вин, которые должны были составить начальную базу системы Wineinconito, чтобы затем —
            показать наглядно весь процесс начала до конца, так сказать, «в деле».
        </p>

    </div>

</div>
<block-quote></block-quote>
<div class="container">
    <div class="about-text-content">
        <p class="about-text">
            Именно после прочтения краткого анонса о программе где-то в пучинах Интернета — я и поспешил
            зарегистрироваться и пойти «подивиться» на нее.
            Вместо обычного (как я думал) прослушивания анонса программы, «ваш покорный слуга» попал прямиком в самую
            гущу ее работы.
        </p>
        <p class="about-text">
            В зале, за дюжиной столов, я обнаружил около 30 «мэтров» энологического рынка, проводящих «слепую»
            дегустацию около 300 вин, которые должны были составить начальную базу системы Wineinconito, чтобы затем —
            показать наглядно весь процесс начала до конца, так сказать, «в деле».
        </p>

    </div>
    <div class="carousel-block">
        <app-carousel></app-carousel>
    </div>
</div>
<app-footer></app-footer>